import { api, currentCreche, currentOrganization } from '../api'

const RegistrationRepository = {
    index (params = {}) {
        return api().$get(`organization/${currentOrganization().uuid}/registrations`, params)
    },

    export (params = {}) {
        return api().$get(`/organization/${currentOrganization().uuid}/registrations/export`, params, {
            responseType: 'blob'
        })
    },

    exportRemunerations (payload) {
        return api().$post(`/organization/${currentOrganization().uuid}/registrations/remunerations/export`, payload, { responseType: 'blob' })
    },

    exportRemunerationsByFilters (payload) {
        return api().$post(`/organization/${currentOrganization().uuid}/registrations/remunerations/export-by-filter`, payload, { responseType: 'blob' })
    },

    show (registrationUuid, params = {}) {
        return api().$get(`organization/${currentOrganization().uuid}/registrations/${registrationUuid}`, params)
    },

    update (registrationUuid, payload) {
        return api().$put(`organization/${currentOrganization().uuid}/registrations/${registrationUuid}`, payload)
    },

    delete (registrationUuid) {
        return api().$delete(`organization/${currentOrganization().uuid}/registrations/${registrationUuid}`)
    },

    detachCreche (registrationUuid) {
        return api().$post(`organization/${currentOrganization().uuid}/registrations/${registrationUuid}/creche/detach`)
    },

    clone (registrationUuid, payload = {}) {
        return api().$post(`organization/${currentOrganization().uuid}/registrations/${registrationUuid}/clone`, payload)
    },

    getPreDemandeOne (registrationUuid, numeroPreDemande) {
        return api().$get(`organization/${currentOrganization().uuid}/registrations/${registrationUuid}/fetch-one-pre-demandes/${numeroPreDemande}`)
    },

    updateBulkStatus (payload) {
        return api().$patch(`/organization/${currentOrganization().uuid}/registrations/bulk/update-status`, payload)
    },

    updateBulkCreche (payload) {
        return api().$patch(`/organization/${currentOrganization().uuid}/registrations/bulk/update-creche`, payload)
    }
}

export default RegistrationRepository
